module.exports = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


//# sourceMappingURL=ar-AE.main.js.map
